import { useEffect } from 'react';
import { useUnityContext } from 'react-unity-webgl';

export const useUnityMessaging = (unityContextConfig) => {
  const { unityProvider, sendMessage, isLoaded, loadingProgression } = useUnityContext(unityContextConfig);

  // Send initial data when Unity loads
  useEffect(() => {
    if (isLoaded) {
      //const gameData = { playerName: "Alice", score: 1500 };
      sendMessage("ReactDataController", "ReceiveDataFromReact", "button_pressed");
    }
  }, [isLoaded, sendMessage]);

  // Custom messaging functions
  const sendPlayerData = (playerData) => {
    if (isLoaded) {
      sendMessage("ReactDataController", "ReceiveDataFromReact", JSON.stringify(playerData));
    } else {
      console.warn("Unity not yet loaded");
    }
  };

  return {
    unityProvider,
    isLoaded,
    loadingProgression,
    sendPlayerData,
  };
};
